/** 读取后端统一响应外壳中的业务数据载荷。 */
export function readApiEnvelopeData(response) {
    const envelope = response.data;
    return envelope?.data;
}
